import { render, staticRenderFns } from "./CardNews.vue?vue&type=template&id=2ea02152"
import script from "./CardNews.vue?vue&type=script&lang=js"
export * from "./CardNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports